import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { SearchBox } from '~/modules/common/components';
import useProjectFacets from '~/modules/projects/useFacets';
import { useClientProjectsContext } from '../ClientProjectsContext';

const useStyles = makeStyles(theme => ({
  root: {
    paddingRight: theme.spacing(2),
    flexGrow: 1
  }
}));

export const ProjectSearchBox = ({ classes }) => {
  const cls = useStyles({ classes });
  const { searchCriteria, setSearchCriteria } = useClientProjectsContext();
  const { facets, showCostOverBudgetOptions } = useProjectFacets({
    skipClient: true
  });

  return (
    <div className={cls.root}>
      <SearchBox
        facets={facets}
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        showCostOverBudgetOptions={showCostOverBudgetOptions}
      />
    </div>
  );
};

ProjectSearchBox.propTypes = {
  classes: PropTypes.object
};

export default ProjectSearchBox;
